import { Action } from '@ngrx/store';

import { LoadMediaInputApiModel, CreateMediaInputApiModel } from '@app/store/http/models/input';
import { LoadMediaOutputApiModel } from '@app/store/http/models/output';
import { ResponsePaginationApiModel } from '@framework/models/api-models';

export enum ActionTypes {
    LOAD = '[Media] Load',
    LOAD_SUCCESS = '[Media] Load Success',
    LOAD_FAILURE = '[Media] Load Failure',

    CREATE = '[Media] Create',
    CREATE_SUCCESS = '[Media] Create Success',
    CREATE_FAILURE = '[Media] Create Failure',

    CHECK_ASSET_READY_OR_NOT = '[Media] Check asset ready or not',
    PASS_DATA_MOBILE = '[Media] Pass Media',

    GET_VIDEO_CHUNKS = '[Media] Get video chunks',

    GET_EXTERNAL_BLOB = '[Media] Get external video blob',

    CHECK_VIDEO_PROCESSING = '[Media] Check video processing',

    NORMAL_VIDEO_UPLOAD ='[Media] Normal Upload Video',

    MEDIA_READY = '[Media] Media Ready',

    RESET_STATE = '[Media] Reset State'
    

  
};


export class Load implements Action {
    readonly type = ActionTypes.LOAD;

    constructor(public payload: LoadMediaInputApiModel, public companyId: number) { }
}

export class PassMobileInformation implements Action {
    readonly type = ActionTypes.PASS_DATA_MOBILE;

    constructor(public file:any, public isVideo:boolean) { }
}


export class GetVideochunks implements Action {
    readonly type = ActionTypes.GET_VIDEO_CHUNKS;

    constructor(public file:any) { }
}

export class CheckVideoProcessing implements Action {
    readonly type = ActionTypes.CHECK_VIDEO_PROCESSING;

    constructor(public isProcessing:boolean) { }
}

export class NormalVideoUpload implements Action{
    readonly type = ActionTypes.NORMAL_VIDEO_UPLOAD;

    constructor(public isNormal:boolean) { }
}


export class LoadSuccess implements Action {
    readonly type = ActionTypes.LOAD_SUCCESS;

    constructor(public response: ResponsePaginationApiModel<LoadMediaOutputApiModel>) { }
}
export class LoadFailure implements Action {
    readonly type = ActionTypes.LOAD_FAILURE;

    constructor(public error: any) { }
}

export class Create implements Action {
    readonly type = ActionTypes.CREATE;

    constructor(public companyId: number, public payload: CreateMediaInputApiModel) { }
}

export class CreateSuccess implements Action {
    readonly type = ActionTypes.CREATE_SUCCESS;

    constructor(public response: LoadMediaOutputApiModel) { }
}

export class CreateFailure implements Action {
    readonly type = ActionTypes.CREATE_FAILURE;

    constructor(public error: any) { }
}

export class Reset implements Action {
    readonly type = ActionTypes.RESET_STATE;
}

export class checkAssetReadyOrNot implements Action {
    readonly type = ActionTypes.CHECK_ASSET_READY_OR_NOT;
    constructor(public isVideo: boolean, public showText:any,public progressCss?:string) { }
}
export class GetExternalBlob implements Action {
    readonly type = ActionTypes.GET_EXTERNAL_BLOB;
    constructor (public isBlobData:boolean){}
}


/** A video record created before Mux finished now has its playback id. */
export class MediaReady implements Action {
    readonly type = ActionTypes.MEDIA_READY;
    constructor(public media: {
        id: number,
        source: string,
        thumbnail_url?: string,
        asset_id?: any,
        aspect_ratio?: any,
        url?: any
    }) { }
}


export type Actions
    = Load
    | LoadSuccess
    | LoadFailure
    | Create
    | CreateSuccess
    | CreateFailure
    | Reset
    | checkAssetReadyOrNot
    | GetVideochunks
    | CheckVideoProcessing
    | GetExternalBlob
    | MediaReady


